var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":this.$route.query.URL,"id":"frameId","frameborder":"0","width":_vm.VRwidth,"height":_vm.VRheight}}),_c('div',{staticClass:"header"},[_c('van-button',{attrs:{"type":"info","color":"#3F7C53"},on:{"click":_vm.backClick}},[_vm._v("返回")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }